export default {
  API_BASE_URL: 'https://mvpboxing.com/mvpadmin/public/index.php/api/',
};